import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { Container, Grid, Typography, List, ListItem, Button, TextField, InputAdornment } from '@material-ui/core';
import EmailIcon from '@material-ui/icons/Email';
import grey from '@material-ui/core/colors/grey';
import CallIcon from '@material-ui/icons/Call';
import FacebookIcon from '@material-ui/icons/Facebook';
import InstagramIcon from '@material-ui/icons/Instagram';
import TwitterIcon from '@material-ui/icons/Twitter';
import MailchimpSubscribe from "react-mailchimp-subscribe"
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';

import appstore from './appstore.svg'
import playstore from './playstore.png'

import HelpWidget from '../Widget/HelpWidget'
import OffersWidget from '../Widget/OffersWidget'

const useStyles = makeStyles((theme) => ({
    footer1: {
        borderTop: `1px solid ${grey[300]}`,
        marginTop: theme.spacing(9),
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(5),
        // backgroundColor: grey[50],
        width: '100%',
    },
    footer2: {
        height: '45vh',
        width: '100%',
        // backgroundColor: grey[900]
    },
    center: {
        display: "flex",
        flexDirection: 'row',
        justifyContent: "center",
        alignItems: "center",
        flexWrap: 'noWrap'
    },
    link: {
        textDecoration: "none",
        cursor: "pointer",
        color: grey[500]
    },
    social: {
        textDecoration: "none",
        color: grey[700],
        marginRight: theme.spacing(3)
    }
}));

const MAIL_CHIMP_URL = "https://desicooks.us7.list-manage.com/subscribe/post?u=9a34056800ad635229a4e1d8e&amp;id=93cd6532ad"

const DisplayingErrorMessagesSchema = Yup.object().shape({
    EMAIL: Yup.string().trim().email("Invalid format").nullable().required('Required'),
});

const Footer = () => {
    const classes = useStyles()
    return (
        <div id="footer" >
            <div className={classes.footer1}>
                <Container>
                    <Grid container spacing={2}>
                        <Grid item sm={2} >
                            <List>
                                <ListItem>
                                    <Typography component="h5" variant="body2" align="left">
                                        COMPANY
                                    </Typography>
                                </ListItem>
                                <ListItem>
                                    <Typography component="span" variant="caption" align="left">
                                        <a href="/about.html" className={classes.link}>
                                            About us
                                             </a>
                                    </Typography>
                                </ListItem>
                                <ListItem>
                                    <Typography component="span" variant="caption" align="left">
                                        <a href="/terms.html" className={classes.link}>
                                            Terms & Conditions
                                        </a>
                                    </Typography>
                                </ListItem>
                                <ListItem>
                                    <Typography component="span" variant="caption" align="left">
                                        <a href="/privacy.html" className={classes.link}>
                                            Privacy Policy
                                        </a>
                                    </Typography>
                                </ListItem>
                                <ListItem>
                                    <Typography component="span" variant="caption" align="left">
                                        <a href="/refund.html" className={classes.link}>
                                            Refund Policy
                                        </a>
                                    </Typography>
                                </ListItem>
                            </List>
                        </Grid>

                        <Grid item sm={2}>
                            <List>
                                <ListItem>
                                    <Typography component="h5" variant="body2" align="left">
                                        HELP & CONTACT
                                    </Typography>
                                </ListItem>

                                <ListItem>
                                    <Typography component="span" variant="caption" align="left">
                                        <HelpWidget footer={true} />
                                    </Typography>
                                </ListItem>

                                <ListItem>
                                    <Typography component="span" variant="caption" align="left">
                                        <a href="mailto:operations@desicooks.in?subject=support" className={classes.link}>
                                            <div className={classes.center}><EmailIcon /> <span> Email Us </span></div>
                                        </a>
                                    </Typography>
                                </ListItem>

                                <ListItem>
                                    <Typography component="span" variant="caption" align="left">
                                        <a href="tel:97807 97807" className={classes.link}>
                                            <div className={classes.center}><CallIcon /> <span>97807 97807</span></div>
                                        </a>
                                    </Typography>
                                </ListItem>
                            </List>
                        </Grid>

                        <Grid item sm={2}>
                            <List>
                                <ListItem>
                                    <Typography component="h5" variant="body2" align="left">
                                        MORE FROM US
                                    </Typography>
                                </ListItem>
                                <ListItem>
                                    <Typography component="span" variant="caption" align="left">
                                        <OffersWidget footer={true} />
                                    </Typography>
                                </ListItem>
                            </List>
                        </Grid>

                        <Grid item sm={6}>
                            <List>
                                <ListItem>
                                    <Typography component="h5" variant="body2" align="left">
                                        SUBSCRIBE TO DESICOOKS NEWSLETTER
                                     </Typography>
                                </ListItem>
                                <ListItem>
                                    <MailchimpSubscribe
                                        url={MAIL_CHIMP_URL}
                                        render={({ subscribe, status, message }) => (

                                            <div style={{ width: '100%' }}>
                                                <Formik
                                                    initialValues={{
                                                        EMAIL: '',
                                                    }}
                                                    enableReinitialize={true}
                                                    validationSchema={DisplayingErrorMessagesSchema}
                                                    onSubmit={values => {
                                                        subscribe(values)
                                                    }}
                                                >
                                                    {({ errors, touched }) => (
                                                        <Form>

                                                            <Field name="EMAIL" type="text">
                                                                {({
                                                                    field, // { name, value, onChange, onBlur }
                                                                    form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
                                                                    meta,
                                                                }) => (
                                                                        <div>
                                                                            <TextField
                                                                                {...field}
                                                                                autoComplete="off"
                                                                                fullWidth
                                                                                label="Enter Your Email"
                                                                                variant="outlined"
                                                                                id="newsletter-input"
                                                                                InputProps={{
                                                                                    endAdornment: <InputAdornment position="end">
                                                                                        <Button type="submit" >SUBSCRIBE</Button>
                                                                                    </InputAdornment>,
                                                                                }}
                                                                            />
                                                                            {meta.touched && meta.error && <div className="error">{meta.error}</div>}
                                                                        </div>
                                                                    )}
                                                            </Field>


                                                        </Form>
                                                    )}
                                                </Formik>
                                                {status === "sending" && <div style={{ color: "#272727" }}>Sending...</div>}
                                                {status === "error" && <div style={{ color: "#e84118" }} dangerouslySetInnerHTML={{ __html: message }} />}
                                                {status === "success" && <div style={{ color: "#2ecc71" }}>Subscribed</div>}
                                            </div>
                                        )}
                                    />

                                </ListItem>
                                <ListItem id="download">

                                    <a href="https://apple.com/app-store/" rel="noopener noreferrer" target="_blank" className={classes.link}>
                                        <img alt="app store link" src={appstore} />
                                    </a>

                                    <a href="https://play.google.com/store" rel="noopener noreferrer" target="_blank" className={classes.link}>
                                        <img alt="play store link" src={playstore} height="60px" />
                                    </a>

                                </ListItem>

                                <ListItem>
                                    <Typography component="p" variant="caption" align="left">
                                        <a href="#" className={classes.social}>
                                            <FacebookIcon />
                                        </a>
                                    </Typography>
                                    <Typography component="p" variant="caption" align="center">
                                        <a href="#" className={classes.social}>
                                            <InstagramIcon />
                                        </a>
                                    </Typography>
                                    <Typography component="p" variant="caption" align="right">
                                        <a href="#" className={classes.social}>
                                            <TwitterIcon />
                                        </a>
                                    </Typography>


                                </ListItem>
                            </List>
                        </Grid>

                    </Grid>



                </Container>
            </div>
            {/* <div className={classes.footer2}>
                <Container>
                    hello
            </Container>
            </div> */}
        </div>
    )
}

export default Footer